import type { State } from './typings'

export const initialState: State = {
  isOpen: false,
  current: undefined,
  activityTypes: [],
  deleteDialogOpened: false,
  underDeletion: undefined,
}
